<template>
    <div>
        <div class="container">
            <router-view/>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
        }
    },
    components: {},
    methods: {
        logout() {
            this.$store.dispatch('logout')
                .then(() => {
                    this.$router.push({name: 'login'});
                })
        },
        isActive(str) {
            return this.$router.currentRoute.name ? this.$router.currentRoute.name.includes(str) : false;
        }
    }
}
</script>